
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, append, singleton, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Followers from "../../public/assets/icons/Followers.svg";
import User_Multiple_Group from "../../public/assets/icons/User_Multiple_Group.svg";
import Shipment_Return from "../../public/assets/icons/Shipment_Return.svg";
import Following from "../../public/assets/icons/Following.svg";
import { isEmpty, sortByDescending, map, partition, singleton as singleton_1, toArray, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { BlockHeader, SmallTextValue, TextValue } from "../Components/Text.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TextButton, IconButton } from "../Components/Button.js";
import Delete_1 from "../../public/assets/icons/Delete_1.svg";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { now, compare, toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ConfirmationDialog } from "../Components/Dialog.js";
import { Msg } from "./Types.js";
import { unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

function OpenNotification(props) {
    let elems_4, elems, elems_3;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[auto_1fr]", "gap-5", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "self-center"])], (elems = toList(delay(() => {
        let matchValue;
        return singleton((matchValue = props.OpenNotification.AssignmentType, (matchValue === "userToStorage") ? Followers() : ((matchValue === "userToUser") ? User_Multiple_Group() : ((matchValue === "returnRequestFromStorage") ? Shipment_Return() : Following()))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-center"])], (elems_2 = toList(delay(() => {
            let matchValue_1;
            return append(singleton(createElement(TextValue, {
                FontWeight: "semiBold",
                TestId: "",
                Text: (matchValue_1 = props.OpenNotification.AssignmentType, (matchValue_1 === "userToStorage") ? t("dashboard.open_notifications_back_to_storage") : ((matchValue_1 === "userToUser") ? t("dashboard.open_notifications_user_to_user") : ((matchValue_1 === "returnRequestFromStorage") ? t("dashboard.open_notifications_requested_by_storage") : t("dashboard.open_notifications_assignment")))),
            })), delay(() => {
                let elems_1;
                const matchValue_2 = props.OnDelete;
                if (matchValue_2 == null) {
                    return singleton(defaultOf());
                }
                else {
                    const onDelete = matchValue_2;
                    return singleton(createElement(IconButton, {
                        ComponentState: "enabled",
                        Icon: reactElement("div", createObj(ofArray([["className", join(" ", ["h-2", "w-2"])], (elems_1 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))),
                        OnClick: () => {
                            onDelete(props.OpenNotification.NotificationId);
                        },
                        TestId: "delete-notification-button",
                    }));
                }
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let matchValue_3, arg_3, arg_5, arg_7, arg_1;
            return append(singleton(createElement(TextValue, {
                FontWeight: "normal",
                TestId: "",
                Text: (matchValue_3 = props.OpenNotification.AssignmentType, (matchValue_3 === "userToStorage") ? ((arg_3 = {
                    sender_name: props.OpenNotification.Sender,
                    storage_name: props.OpenNotification.Storage,
                }, i18n.t("dashboard.open_notifications_back_to_storage_detail", arg_3))) : ((matchValue_3 === "userToUser") ? ((arg_5 = {
                    receiver_name: props.OpenNotification.Receiver,
                    sender_name: props.OpenNotification.Sender,
                }, i18n.t("dashboard.open_notifications_user_to_user_detail", arg_5))) : ((matchValue_3 === "returnRequestFromStorage") ? ((arg_7 = {
                    receiver_name: props.OpenNotification.Receiver,
                    sender_name: props.OpenNotification.Sender,
                    storage_name: props.OpenNotification.Storage,
                }, i18n.t("dashboard.open_notifications_requested_by_storage_detail", arg_7))) : ((arg_1 = {
                    receiver_name: props.OpenNotification.Receiver,
                    sender_name: props.OpenNotification.Sender,
                    storage_name: props.OpenNotification.Storage,
                }, i18n.t("dashboard.open_notifications_assignment_detail", arg_1)))))),
            })), delay(() => append(singleton(createElement(TextButton, {
                ComponentState: "enabled",
                Label: props.OpenNotification.EntityName,
                OnClick: () => {
                    RouterModule_nav(ofArray(toArray(props.OpenNotification.EntityPath)), 1, 1);
                },
                TestId: "",
                Variant: "blueButton",
            })), delay(() => append(singleton(createElement(SmallTextValue, {
                FontWeight: "small",
                TestId: "",
                Text: toString(props.OpenNotification.Timestamp, "dd.MM.yyyy HH:mm"),
            })), delay(() => {
                const matchValue_4 = props.OpenNotification.PausedUntil;
                if (matchValue_4 == null) {
                    return singleton(defaultOf());
                }
                else {
                    const pausedUntil = matchValue_4;
                    return singleton(createElement(SmallTextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: concat(t("assignment_notification.paused_until"), ": ", ...toString(toLocalTime(pausedUntil), "dd.MM.yyyy")),
                    }));
                }
            }))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function OpenNotificationsCard(props) {
    let elems_2;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_2 = toList(delay(() => {
        let Title;
        return append(singleton(createElement(ConfirmationDialog, (Title = t("general.remove"), {
            Description: t("dashboard.delete_notification_confirmation"),
            FormState: props.FormState,
            IsOpen: props.NotificationToDelete != null,
            OnClose: () => {
                props.Dispatch(new Msg(2, []));
            },
            OnConfirm: () => {
                props.Dispatch(new Msg(1, []));
            },
            Title: Title,
        }))), delay(() => {
            let elems;
            const patternInput_1 = partition((notification) => {
                const matchValue = notification.PausedUntil;
                if (matchValue == null) {
                    return false;
                }
                else {
                    return compare(matchValue, now()) > 0;
                }
            }, props.OpenNotifications);
            const pausedNotifications = patternInput_1[0];
            const notificationElement = (notification_1) => createElement(OpenNotification, {
                OnDelete: unwrap(notification_1.CanDelete ? ((notificationId) => {
                    props.Dispatch(new Msg(0, [notificationId]));
                }) : undefined),
                OpenNotification: notification_1,
            });
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
                Text: t("dashboard.open_notifications"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(map(notificationElement, sortByDescending((_arg_2) => _arg_2.Timestamp, patternInput_1[1], {
                Compare: (x, y) => (compare(x, y) | 0),
            })), delay(() => {
                let elems_1;
                return !isEmpty(pausedNotifications) ? append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems_1 = [createElement(BlockHeader, {
                    Text: t("dashboard.paused_notifications"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => map(notificationElement, sortByDescending((_arg_3) => _arg_3.Timestamp, pausedNotifications, {
                    Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
                })))) : empty();
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

